import { Controller } from '@hotwired/stimulus';

const INTERVAL_MS = 60 * 1000;
const ACTIVITY_EVENTS = ['keydown', 'input', 'change', 'pointerdown', 'scroll', 'focusin'];

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute('content') : '';
}

/**
 * 組合員情報の編集画面で操作している間、自分の編集中の状態（リース）を延長するStimulusコントローラ（要件4-2）
 * 1分ごとに、その間に操作があったときだけサーバーへ知らせる。開いたまま操作しなければ送らず、リースは期限で切れる。
 * 強制解除や、期限切れの後に他の管理者が開いたことでリースを失ったら（4xx）、それ以降は送らない。
 * @extends Controller
 */
export default class extends Controller {
  static targets = ['expiresAt'];
  static values = { url: String };

  connect() {
    this.active = false;
    this.markActive = () => { this.active = true; };
    ACTIVITY_EVENTS.forEach((type) => document.addEventListener(type, this.markActive, { capture: true, passive: true }));
    this.timer = setInterval(() => this.beat(), INTERVAL_MS);
  }

  disconnect() {
    this.stop();
  }

  stop() {
    clearInterval(this.timer);
    ACTIVITY_EVENTS.forEach((type) => document.removeEventListener(type, this.markActive, { capture: true }));
  }

  async beat() {
    if (!this.active) return;
    this.active = false;

    try {
      const response = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: { 'Accept': 'application/json', 'X-CSRF-Token': csrfToken() }
      });
      if (response.status >= 400 && response.status < 500) {
        this.stop();
        return;
      }
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const { expires_at_text: expiresAtText } = await response.json();
      this.expiresAtTarget.textContent = expiresAtText;
    } catch {
      // 失敗しても送り直さない。次に操作があれば、その回に送る
      // 送り直すと、操作をやめた後に通信が戻ったときに、放置された画面のリースを延ばしてしまうため
    }
  }
}
